import React, { Component, PropTypes } from 'react';
import EditCustomerInfo from './edit-customer-info';
import { lang } from '../../strings';

export default class CustomerInfo extends Component {

   constructor(props) {
      super(props);

      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         editCustomerInfo: false
      };
   }

   render() {
      let { customer } = this.props;
      let { customerName, orgNumber, contactName, emailAddress, phoneNumber } = customer.toJS();
      let { editCustomerInfo } = this.state;

      return (
         <div>
            <a href="#" className="link" style={{float: 'right'}} onClick={this.showEdit}>{lang.customer.edit.button}</a>
            <h2 className="h5 color-dark-blue">{customerName} ({orgNumber})</h2>
            <strong>{lang.customer.contactName}</strong><br />
            {contactName}<br />
            {emailAddress}<br />
            {phoneNumber}
            {editCustomerInfo ? <EditCustomerInfo customer={customer} onSubmit={this.updateCustomer} onClose={this.hideEdit} /> : null}
         </div>
      );
   }

   updateCustomer = data => {
      this.props.updateCustomerDetails(data);
      this.setState({ editCustomerInfo: false });
   };

   showEdit = ev => {
      ev.preventDefault();
      this.setState({ editCustomerInfo: true });
   };

   hideEdit = ev => {
      ev.preventDefault();
      this.setState({ editCustomerInfo: false });
   };
}

CustomerInfo.propTypes = {
   customer: PropTypes.object.isRequired,
   updateCustomerDetails: PropTypes.func.isRequired
};